export default "__VITE_ASSET__8ca2cc1e__"